import React, {useEffect, useState} from 'react';

const CalendarTileHighlight = (props) => {

    return (
        <p>CalendarTileHighlight</p>
    );
};

export default CalendarTileHighlight;
